// DP227 — pure day/week helpers shared by the schedule cards.
import { parseDay, isWorkDay, workingDaysBetween, startOfWeek, dayKey, DEFAULT_CALENDAR } from './workingDays';

export function todayLocal() { const d = new Date(); return new Date(d.getFullYear(), d.getMonth(), d.getDate()); }

export function anchorDay(today, cal = DEFAULT_CALENDAR) {
  const d = new Date(today); let g = 0;
  while (!isWorkDay(d, cal) && g < 14) { d.setDate(d.getDate() + 1); g += 1; }
  return d;
}

export function buildWeeks(anchor, cal = DEFAULT_CALENDAR, count = 4) {
  const out = []; const w0 = startOfWeek(anchor);
  for (let w = 0; w < count; w += 1) {
    const days = [];
    for (let i = 0; i < 7; i += 1) {
      const d = new Date(w0); d.setDate(d.getDate() + w * 7 + i);
      if (isWorkDay(d, cal) || (cal.work_week || []).includes(i)) days.push(d);
    }
    out.push({ days });
  }
  return out;
}

export function subStateOf(task, subNames) {
  const who = String(task.assigned_to || '').toLowerCase();
  if (!who || task.status === 'completed') return null;
  if (!subNames.some(n => who.includes(n) || n.includes(who))) return null;
  if (task.contractor_response === 'confirmed') return null;
  return task.contractor_response === 'declined' ? 'declined' : 'wait';
}

export function toItem(t, subNames, today, cal) {
  const start = parseDay(t.start_date) || parseDay(t.due_date);
  const due = parseDay(t.due_date);
  if (!due) return null;
  const done = t.status === 'completed';
  const sub = subStateOf(t, subNames);
  const late = !done && (due < today || sub === 'declined');
  return { id: t.id, project_id: t.project_id, title: t.title, start, due, done, sub, late,
    who: (t.assigned_to || '').trim().split(/\s+/)[0],
    overBy: !done && due < today ? workingDaysBetween(due, today, cal) : 0 };
}

export function itemsOnDay(items, d, { today, anchor }) {
  const key = dayKey(d); const isAnchor = key === dayKey(anchor);
  return items.filter(it => (it.start <= d && d < it.due) || (isAnchor && it.late && it.due <= today && !(it.start <= d && d < it.due)));
}

export function rangeLabel(days) {
  const a = days[0]; const b = days[days.length - 1];
  const f = (x) => x.toLocaleDateString('en-US', { month: 'short', day: 'numeric' });
  return `${f(a)}–${b.getMonth() === a.getMonth() ? b.getDate() : f(b)}`;
}

export const DAY_NAMES = ['Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat', 'Sun'];

export function dayLabel(d) { return `${DAY_NAMES[(d.getDay() + 6) % 7]} ${d.getDate()}`; }
